var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SToolbar',[_c('KpIcon',{attrs:{"icon-cls":"agenda","color":"grey","left":""}}),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('agenda')))])],1),_c('EventList',{attrs:{"session-key":"event-list","height":"var(--usable-height-with-double-toolbar)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }